// Endereçamento · alocar e realocar volumes entre endereços
import { repo, db } from '../client.js';
import { escapeHTML, NUM, QTY, DT, SHORT } from '../shared.js';

export async function viewEnderecamento($c) {
  $c.innerHTML = `
    <header class="page-head">
      <div>
        <div class="kicker">CHÃO DO GALPÃO</div>
        <h1>Endereçamento e <strong>realocação</strong></h1>
        <p class="lead">Mapa de ocupação física por endereço. Movimentar um volume entre prateleiras registra log auditável em <span class="mono-inline">realocacao_log</span>.</p>
      </div>
    </header>

    <div class="stats" id="enderec-stats"></div>

    <div class="grid-2">
      <div class="card">
        <div class="card-head"><h2>Mapa de ocupação <span class="count" id="end-count">…</span></h2></div>
        <div id="end-map" class="end-map"><div class="empty"><span class="spinner"></span>Carregando endereços…</div></div>
      </div>
      <div class="card">
        <div class="card-head"><h2>Realocar volume</h2></div>
        <p class="text-sm text-mute" style="margin-bottom:14px;">Escolha um volume e o novo endereço. Movimento é logado automaticamente.</p>
        <form id="form-realoc" class="form-stack">
          <label>Volume<select id="ra-vol" required><option value="">— selecionar —</option></select></label>
          <label>Novo endereço<select id="ra-end" required><option value="">— selecionar —</option></select></label>
          <label>Motivo
            <select id="ra-motivo">
              <option value="realocacao">Realocação de slotting</option>
              <option value="recebimento">Recebimento inicial</option>
              <option value="quarentena">Mover para quarentena</option>
              <option value="picking">Movido para picking</option>
              <option value="expedicao">Pronto para expedição</option>
              <option value="ajuste">Ajuste manual</option>
            </select>
          </label>
          <label>Responsável<input id="ra-resp" placeholder="seu nome"></label>
          <button type="submit" class="btn btn-blue">→ Mover volume</button>
        </form>
      </div>
    </div>

    <div class="card">
      <div class="card-head"><h2>Histórico de realocações <span class="count" id="ra-log-count">…</span></h2></div>
      <div id="ra-log"></div>
    </div>
  `;

  // 1. carrega ocupação
  let ocupacao = [];
  try { ocupacao = await repo.ocupacaoEnderecos(); } catch (e) { /* */ }
  const mapEl = document.getElementById('end-map');
  document.getElementById('end-count').textContent = ocupacao.length;

  if (ocupacao.length === 0) {
    mapEl.innerHTML = `<div class="empty">Nenhum endereço cadastrado. Vá em <strong>Etiquetas</strong> → cadastrar endereços (formato A-03-1-02).</div>`;
  } else {
    mapEl.innerHTML = ocupacao.map(o => {
      const ocup = Number(o.ocupacao_pct || 0);
      const cls = ocup === 0 ? 'vazio' : ocup < 50 ? 'baixo' : ocup < 90 ? 'medio' : 'alto';
      return `
        <div class="end-cell ${cls} ${o.tipo}">
          <div class="end-codigo">${escapeHTML(o.endereco_codigo)}</div>
          <div class="end-info">${o.volumes || 0} vol · ${QTY(o.qtd_total)}</div>
          ${o.golden_zone ? '<div class="end-tag">★</div>' : ''}
          ${o.skus && o.skus.length ? `<div class="end-skus" title="${o.skus.filter(Boolean).join(', ')}">${o.skus.filter(Boolean).slice(0, 2).map(s => SHORT(s, 14)).join(' · ')}</div>` : ''}
        </div>`;
    }).join('');
  }

  // 2. stats
  const total = ocupacao.length;
  const vazios = ocupacao.filter(o => (o.volumes || 0) === 0).length;
  const cheios = ocupacao.filter(o => Number(o.ocupacao_pct || 0) >= 90).length;
  const golden = ocupacao.filter(o => o.golden_zone).length;
  document.getElementById('enderec-stats').innerHTML = `
    <div class="stat"><div class="label">Endereços ativos</div><div class="value">${NUM(total)}</div></div>
    <div class="stat success"><div class="label">Vazios</div><div class="value">${NUM(vazios)}</div></div>
    <div class="stat ${cheios > 0 ? 'warning' : ''}"><div class="label">≥ 90% ocupados</div><div class="value">${NUM(cheios)}</div></div>
    <div class="stat"><div class="label">Golden zone</div><div class="value">${NUM(golden)}</div></div>
  `;

  // 3. dropdowns
  try {
    const [vols, ends] = await Promise.all([repo.volumesAtivos({ limit: 200 }), repo.listEnderecos()]);
    document.getElementById('ra-vol').innerHTML += vols.map(v =>
      `<option value="${escapeHTML(v.volume_codigo)}">${escapeHTML(v.volume_codigo)} · ${escapeHTML(SHORT(v.sku_codigo || '—', 14))} · ${escapeHTML(v.endereco || 'sem end')}</option>`
    ).join('');
    document.getElementById('ra-end').innerHTML += ends.map(e =>
      `<option value="${escapeHTML(e.endereco_codigo)}">${escapeHTML(e.endereco_codigo)} · ${escapeHTML(e.tipo || 'estoque')}${e.golden_zone ? ' ★' : ''}</option>`
    ).join('');
  } catch (e) { /* */ }

  // 4. submit realocação
  document.getElementById('form-realoc').addEventListener('submit', async (e) => {
    e.preventDefault();
    try {
      const vol = document.getElementById('ra-vol').value;
      const end = document.getElementById('ra-end').value;
      const mot = document.getElementById('ra-motivo').value;
      const resp = document.getElementById('ra-resp').value || '';
      const r = await repo.realocarVolume({ volume_codigo: vol, endereco_destino: end, motivo: mot, responsavel: resp });
      alert(`✓ Volume ${vol} movido: ${r.from || '∅'} → ${r.to}`);
      // refresh
      viewEnderecamento($c);
    } catch (err) { alert('Erro: ' + err.message); }
  });

  // 5. histórico
  try {
    const { data: hist } = await db.from('realocacao_log').select('*').order('created_at', { ascending: false }).limit(30);
    document.getElementById('ra-log-count').textContent = hist?.length || 0;
    if (!hist || hist.length === 0) {
      document.getElementById('ra-log').innerHTML = '<div class="empty">Sem realocações ainda.</div>';
    } else {
      document.getElementById('ra-log').innerHTML = `
        <table class="tbl">
          <thead><tr><th>Quando</th><th>Volume</th><th>SKU</th><th class="num">Qtd</th><th>De</th><th>Para</th><th>Motivo</th><th>Responsável</th></tr></thead>
          <tbody>${hist.map(r => `
            <tr>
              <td class="mono">${DT(r.created_at)}</td>
              <td class="mono">${escapeHTML(r.volume_codigo || '—')}</td>
              <td class="mono">${escapeHTML(SHORT(r.sku_codigo || '—', 22))}</td>
              <td class="num">${QTY(r.qtd)}</td>
              <td class="mono text-mute">${escapeHTML(r.endereco_origem || '∅')}</td>
              <td class="mono strong">${escapeHTML(r.endereco_destino || '∅')}</td>
              <td><span class="pill pill-mute">${escapeHTML(r.motivo)}</span></td>
              <td>${escapeHTML(r.responsavel || '—')}</td>
            </tr>`).join('')}
          </tbody>
        </table>`;
    }
  } catch (e) {
    document.getElementById('ra-log').innerHTML = `<div class="empty err">${escapeHTML(e.message)}</div>`;
  }
}
